import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

// Светлый градиентный фон
export const StarryBackground = styled('div')(() => {
    return {
        position: 'relative',
        height: '100vh',
        width: '100vw',
        background: 'linear-gradient(110deg, rgba(59, 190, 219, 1) 20%, rgba(238, 234, 252, 1) 112%, rgba(227, 247, 250, 1) 100%)',
        overflow: 'hidden',
    };
});

// Эффект туманности
export const NebulaEffect = styled(Box)(() => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `
        radial-gradient(ellipse at 20% 50%, rgba(59, 190, 219, 0.2) 0%, transparent 50%),
        radial-gradient(ellipse at 80% 20%, rgba(34, 211, 238, 0.15) 0%, transparent 50%),
        radial-gradient(ellipse at 40% 80%, rgba(6, 182, 212, 0.25) 0%, transparent 50%)
    `,
    animation: 'nebulaDrift 30s ease-in-out infinite',
    zIndex: 2,
    '@keyframes nebulaDrift': {
        '0%, 100%': {
            transform: 'translateX(0) translateY(0) rotate(0deg)',
            opacity: 0.7,
        },
        '25%': {
            transform: 'translateX(-20px) translateY(-10px) rotate(1deg)',
            opacity: 0.8,
        },
        '50%': {
            transform: 'translateX(20px) translateY(20px) rotate(-1deg)',
            opacity: 0.6,
        },
        '75%': {
            transform: 'translateX(10px) translateY(-20px) rotate(0.5deg)',
            opacity: 0.9,
        },
    },
}));

// Контейнер для контента
export const ContentContainer = styled(Box)(() => ({
    position: 'relative',
    zIndex: 10,
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
}));

// Заголовок с логотипом
export const HeaderContainer = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '16px 24px',
    borderBottom: '1px solid rgba(59, 130, 246, 0.3)',
}));

export const TitleContainer = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
}));

// Кнопка назад в космическом стиле
export const BackButton = styled(Button)(() => ({
    color: 'white',
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
        color: 'rgba(6, 182, 212, 0.8)',
        textShadow: '0 0 10px rgba(6, 182, 212, 0.5)',
        backgroundColor: 'transparent',
    },
}));

// Контейнер для iframe
export const IframeContainer = styled(Box)(() => ({
    flex: 1,
    margin: '0 24px 24px 24px',
    background: 'rgba(30, 41, 59, 0.3)',
    backdropFilter: 'blur(16px)',
    border: '1px solid rgba(59, 130, 246, 0.2)',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
}));
